import { render, staticRenderFns } from "./PoultryDetails.vue?vue&type=template&id=dba3e7b2&scoped=true"
import script from "./PoultryDetails.vue?vue&type=script&lang=js"
export * from "./PoultryDetails.vue?vue&type=script&lang=js"
import style0 from "./PoultryDetails.vue?vue&type=style&index=0&id=dba3e7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba3e7b2",
  null
  
)

export default component.exports